import { isEmpty } from 'lodash';
import React, { createContext, useContext } from 'react';
import { useNumber } from 'react-use';
import { IHookStateSetAction } from 'react-use/lib/misc/hookState';

type SearchPageValues = {
  currentTabIdx: number;
  setCurrentTabIdx: (value: IHookStateSetAction<number>) => void;
};
export const SearchPageCtx = createContext<SearchPageValues>(
  {} as SearchPageValues
);

export const SearchPageProvider: React.FC = ({ children }) => {
  const [currentTabIdx, { set: setCurrentTabIdx }] = useNumber(0);
  return (
    <SearchPageCtx.Provider value={{ currentTabIdx, setCurrentTabIdx }}>
      {children}
    </SearchPageCtx.Provider>
  );
};

export const useSearchPageStore = () => {
  const values = useContext(SearchPageCtx);
  if (isEmpty(values))
    throw new Error('useSearchPageStore must be use in SearchPageProvider');
  return values;
};
